import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { OfflineModeService } from './offline-mode.service';
import { Status } from '../dto/status.enum';
import { AuthService } from './auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class BaseCacheService {
  private curEmail: string;
  constructor(
    protected dbService: NgxIndexedDBService,
    protected offlineService: OfflineModeService,
    public authService: AuthService,
    protected modalCtrl: ModalController
  ) {
  }

  protected getCurOrdersDbName(status?: Status[]): string {
    let storeName: string;
    if (status?.includes(Status.OPEN)) {
      storeName = 'orders';
    } else if (
      status?.includes(Status.IN_WORK) ||
      status?.includes(Status.ACCEPTED)
    ) {
      storeName = 'ordersInWork';
    } else {
      storeName = 'ordersCompleted';
    }

    return storeName;
  }

  protected getCurEmail(): string {
    // Текущий субъект — из токена (единый декодер приложения в AuthService). Синхронизируем кэш ВСЕГДА,
    // когда в токене есть email: иначе после бесшовной смены субъекта (обычный вход или имперсонация без
    // перезагрузки) кэш заказов писался/читался бы под ПРЕЖНИМ e-mail. Кэшированное значение отдаём лишь
    // как фолбэк, когда токен уже очищен (операции, завершающиеся в процессе выхода из сессии).
    const email = this.authService.getDecodedAccessToken()?.email;
    if (email) {
      this.curEmail = email;
      return email;
    }
    return this.curEmail;
  }
}
